import { Select } from "antd";
import styled from "styled-components";

const StyledSelect = styled(Select)`
    .ant-select-selection{
        border-color: #b4b6cb;
        min-height: 34px;
    }
`
export default StyledSelect;